const btnTableTileMatOverrides = {
  export: 'Exportar dados',
  addRowLabel: 'adicionar',
  options: 'opções',
  exportChecklist: 'Exportar checklist',
  import: 'Importar',
  importData: 'Importar dados',
};

export default btnTableTileMatOverrides;
